export default __webpack_public_path__ + "static/media/chalkup.0ac52821.png";